export default "__VITE_ASSET__DOHiCPEN__"